(() => {
  'use strict';
  const root = document.currentScript;
  if (!root?.hasAttribute('data-clean-analytics-root') || window['clean-analytics']) return;
  const state = (window['clean-analytics'] = { status: 'scheduled' });
  const setStatus = (status) => {
    state.status = status;
    root.dataset.cleanAnalyticsState = status;
  };
  const query = new URLSearchParams(window.location.search);
  if (query.get('clean_analytics') === 'off' || query.get('perf_test') === '1') {
    setStatus('disabled-for-comparison');
    return;
  }
  const container = root.dataset.cleanAnalyticsContainer;
  const proxy = root.dataset.cleanAnalyticsProxy;
  const bootstrap = root.dataset.cleanAnalyticsBootstrap;
  if (!/^GTM-[A-Z\d]+$/.test(container || '') || proxy !== '/apps/clean-analytics' || !bootstrap) {
    setStatus('invalid-configuration');
    return;
  }
  if (!window.isSecureContext || !navigator.serviceWorker) {
    setStatus('worker-unavailable');
    return;
  }

  // This valid JS identifier is required by GTM's custom data-layer parameter.
  // Keep the existing window.dataLayer and its legacy/app consumers separate.
  const layerName = 'cleanDataLayer';
  let started = false;
  let queued = false;
  let lastConsent = '';
  let latestDetail;
  const consent = () => {
    let recorded;
    try { recorded = window.Shopify?.customerPrivacy?.currentVisitorConsent?.(); } catch { /* Read-only API may be unavailable. */ }
    const analytics = typeof latestDetail?.analyticsAllowed === 'boolean'
      ? latestDetail.analyticsAllowed
      : recorded?.analytics !== 'no';
    const marketing = typeof latestDetail?.marketingAllowed === 'boolean'
      ? latestDetail.marketingAllowed
      : recorded?.marketing === 'yes';
    return {
      // Owner-selected implied analytics consent when no choice is recorded.
      // A recorded refusal wins. No Shopify consent record is written here.
      analytics_storage: analytics ? 'granted' : 'denied',
      ad_storage: marketing ? 'granted' : 'denied',
      ad_user_data: marketing ? 'granted' : 'denied',
      ad_personalization: marketing ? 'granted' : 'denied',
    };
  };
  const command = function () { window[layerName].push(arguments); };

  const start = () => {
    queued = false;
    if (started) return;
    const current = consent();
    if (current.analytics_storage === 'denied') {
      setStatus('disabled-by-choice');
      return;
    }
    if (window.partytown || window[layerName]) {
      setStatus('namespace-conflict');
      return;
    }
    started = true;
    setStatus('starting-worker');
    window[layerName] = [];
    command('consent', 'default', current);
    lastConsent = JSON.stringify(current);
    window[layerName].push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    window.partytown = {
      lib: `${proxy}/lib/`,
      forward: [`${layerName}.push`],
      fallbackTimeout: 0,
    };
    document.addEventListener('pt0', () => setStatus('worker-ready'), { once: true });
    document.addEventListener('clean-analytics-worker-failed', () => setStatus('worker-failed'), { once: true });
    const tag = document.createElement('script');
    tag.type = 'text/partytown';
    tag.setAttribute('data-clean-analytics-gtm', '');
    if (root.dataset.cleanAnalyticsLegacyBridge === 'true') {
      // Explicit data-only exemption from the legacy third-party deferrer.
      // It must leave this inert script inert; Partytown owns its execution.
      tag.setAttribute('data-hadiyah-tp-ok', '1');
    }
    tag.src = `https://www.googletagmanager.com/gtm.js?id=${container}&l=${layerName}`;
    document.head.appendChild(tag);
    const runtime = document.createElement('script');
    runtime.async = true;
    runtime.fetchPriority = 'low';
    runtime.src = bootstrap;
    runtime.addEventListener('error', () => setStatus('bootstrap-failed'), { once: true });
    document.head.appendChild(runtime);
  };
  const schedule = () => {
    if (started || queued) return;
    queued = true;
    if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 2000 });
    else window.setTimeout(start, 0);
  };
  document.addEventListener('visitorConsentCollected', (event) => {
    latestDetail = event.detail;
    if (!started) {
      if (document.readyState === 'complete') schedule();
      return;
    }
    const current = consent();
    const serialized = JSON.stringify(current);
    if (serialized !== lastConsent && state.status !== 'worker-failed' && state.status !== 'bootstrap-failed') {
      command('consent', 'update', current);
      lastConsent = serialized;
    }
  });
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
